import { Hit, OrderData } from '@gamiphy/bl/analytics';
import { Analytics } from './analytics';

export class AnalyticsFactory {
  private static instance: Analytics | undefined;

  public static initialize(): void {
    this.instance = new Analytics();
  }

  /**
   * Wait until instance being ready
   */
  public static async getInstance(): Promise<Analytics> {
    if (this.instance) {
      return this.instance;
    }

    return new Promise((resolve) => {
      const intervalId = setInterval(() => {
        if (this.instance) {
          clearInterval(intervalId);
          resolve(this.instance);
        }
      }, 500);
    });
  }

  /**
   * Set user id to the session
   * @param userId User id value
   */
  public static async setUserId(userId: string): Promise<void> {
    await (await this.getInstance()).setUserId(userId);
  }

  public static async collect(hit: Omit<Hit, 'site'>): Promise<void> {
    await (await this.getInstance()).collect(hit);
  }

  public static async collectProductView(externalProductId: string): Promise<void> {
    await (await this.getInstance()).collectProductView(externalProductId);
  }

  public static async collectAddToCart(externalProductId: string): Promise<void> {
    await (await this.getInstance()).collectAddToCart(externalProductId);
  }

  public static async collectOrderPlace(externalOrderId: string, data?: OrderData): Promise<void> {
    await (await this.getInstance()).collectOrderPlace(externalOrderId, data);
  }
}
